/* Ballast Supply — cart drawer: free-shipping progress bar logic.
   Threshold in store currency (whole number). 0 = store ships free on everything (always "Congrats!").
   Set to e.g. 50 ONLY if a matching Shopify free-shipping rule exists, else the "away from" text is a false claim. */
(function () {
  var THRESHOLD = 50;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;

  function money(cents) {
    try { if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat); } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function update() {
    if (busy) return;
    busy = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var totalMajor = (cart.total_price || 0) / 100;
        document.querySelectorAll('[data-cart-progress]').forEach(function (bar) {
          var textEl = bar.querySelector('[data-shipping-text]');
          var fillEl = bar.querySelector('[data-shipping-fill]');
          if (THRESHOLD <= 0 || totalMajor >= THRESHOLD) {
            if (textEl) textEl.innerHTML = 'Congrats! You get <strong>FREE</strong> shipping!';
            if (fillEl) fillEl.style.width = '100%';
            bar.classList.add('pl-cart-progress--complete');
          } else {
            var remaining = THRESHOLD - totalMajor;
            var pct = Math.max(2, Math.min(100, (totalMajor / THRESHOLD) * 100));
            if (textEl) textEl.innerHTML = "You're only " + money(Math.round(remaining * 100)) + " away from <strong>FREE</strong> shipping!";
            if (fillEl) fillEl.style.width = pct + '%';
            bar.classList.remove('pl-cart-progress--complete');
          }
        });
      })
      .catch(function () {})
      .then(function () { setTimeout(function () { busy = false; }, 150); });
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(update, 220); }
  try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  if (document.readyState !== 'loading') update(); else document.addEventListener('DOMContentLoaded', update);
})();
